import React, { useState } from "react";
import style from "css/calendar.module.css";
import { ReactComponent as Detail } from "asset/calendar/detail.svg";
import { ReactComponent as Vertical } from "asset/calendar/vertical.svg";
import { ReactComponent as Close } from "asset/calendar/close.svg";
import { Popover, Skeleton, Image } from "antd";
import { useTranslation } from "react-i18next";
function MeetingRoomInfoModal(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const close = () => {
    setOpen(false);
  };
  const handleOpenChange = (open) => {
    setOpen(open);
  };
  return (
    <Popover
      placement="right"
      arrow={false}
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
      content={
        <div className={style.meetingRoom_info_popup}>
          <div className={style.meetingRoom_info_wrapper}>
            <div className={style.meetingRoom_info_title}>
              <span>{t("LABEL.TITLE.ROOM_INFO")}</span>
              {props.resource.extendedProps.ENDPOINT_TYPE === "CD1001" ? (
                <Close className="cursor" onClick={close} />
              ) : (
                <></>
              )}
            </div>
            <div className={style.meetingRoom_img}>
              {props.resource.extendedProps.FILE_URL === "" ? (
                <Skeleton.Image
                  style={{
                    width: "350px",
                    height: "150px",
                  }}
                />
              ) : (
                <Image
                  className={style.meetingRoom_img}
                  width={350}
                  src={props.resource.extendedProps.FILE_URL}
                />
              )}
            </div>
            <div className={style.meetingRoom_info_area}>
              <div className={style.meetingRoom_info_label}>
                <span />
                {t("LIST.MEETING_ROOM")}
              </div>
              <div className={style.meetingRoom_info_value}>
                {props.resource.title}
              </div>
            </div>
            <div className={style.meetingRoom_info_area}>
              <div className={style.meetingRoom_info_label}>
                <span />
                {t("LIST.ROOM_CAPACITY")}
              </div>
              <div className={style.meetingRoom_info_value}>
                {props.resource.extendedProps.CAPACITY}
              </div>
            </div>
            <div className={style.meetingRoom_info_area}>
              <div className={style.meetingRoom_info_label}>
                <span />
                {t("LIST.OPENING_HOURS")}
              </div>
              <div className={style.meetingRoom_info_value}>
                {props.resource.extendedProps.OPENTIME === "" ||
                props.resource.extendedProps.CLOSETIME === ""
                  ? t("LIST.ALWAYS_OPEN")
                  : props.resource.extendedProps.OPENTIME +
                    " ~ " +
                    props.resource.extendedProps.CLOSETIME}
              </div>
            </div>
            <div className={style.meetingRoom_info_area}>
              <div className={style.meetingRoom_info_label}>
                <span />
                {t("LABEL.MEETING_LOCATION")}
              </div>
              <div className={style.meetingRoom_info_value}>
                {props.resource.extendedProps.DEPT_NM_PARENT}
              </div>
            </div>
            {Array.isArray(props.resource.extendedProps.FIXTURE) &&
            props.resource.extendedProps.FIXTURE.length > 0 ? (
              <div
                className={`${style.meetingRoom_info_area} ${style.fixture_area}`}
              >
                <div className={style.meetingRoom_info_label}>
                  <span />
                  {t("LABEL.RESOURCE")}
                </div>
                <div className={style.meetingRoom_info_value}>
                  {props.resource.extendedProps.FIXTURE.map((data) => (
                    <div
                      key={data.FIXTURES_ID}
                      className={style.meetingRoom_fixture_item}
                    >
                      <div className={style.meetingRoom_fixture_info}>
                        <div className={style.meetingRoom_fixture_name}>
                          {data.FIXTURES_NM}
                        </div>
                        <div className={style.meetingRoom_fixture_content}>
                          {data.DESCRIPTION}
                        </div>
                      </div>
                      <div className={style.meetingRoom_fixture_cnt}>수량</div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          {props.resource.extendedProps.ENDPOINT_TYPE === "CD1002" ? (
            <>
              <div className={style.vertical_line}>
                <Vertical />
              </div>
              <div className={style.endpoint_info_wrapper}>
                <div className={style.meetingRoom_info_title}>
                  <span>{t("LABEL.TITLE.MEETING_DEVICE")}</span>
                  {props.resource.extendedProps.ENDPOINT_TYPE === "CD1002" ? (
                    <Close className="cursor" onClick={close} />
                  ) : (
                    <></>
                  )}
                </div>
                <div className={style.meetingRoom_info_area}>
                  <div className={style.meetingRoom_info_label}>
                    <span />
                    {t("LABEL.DEVICE_NAME")}
                  </div>
                  <div className={style.meetingRoom_info_value}>
                    {props.resource.extendedProps.ENDPOINT_NM}
                  </div>
                </div>
                <div className={style.meetingRoom_info_area}>
                  <div className={style.meetingRoom_info_label}>
                    <span />
                    {t("LABEL.EQUIPMENT_CODE")}
                  </div>
                  <div className={style.meetingRoom_info_value}>
                    {props.resource.extendedProps.ENDPOINT_ID}
                  </div>
                </div>
                <div className={style.meetingRoom_info_area}>
                  <div className={style.meetingRoom_info_label}>
                    <span />
                    {t("LABEL.EQUIPMENT_NAME")}
                  </div>
                  <div className={style.meetingRoom_info_value}>
                    {props.resource.extendedProps.ENDPOINT_NM}
                  </div>
                </div>
                <div className={style.meetingRoom_info_area}>
                  <div className={style.meetingRoom_info_label}>
                    <span />
                    {t("LABEL.EQUIPMENT_IP")}
                  </div>
                  <div className={style.meetingRoom_info_value}>
                    {props.resource.extendedProps.ENDPOINT_IP}
                  </div>
                </div>
                <div className={style.meetingRoom_info_area}>
                  <div className={style.meetingRoom_info_label}>
                    <span />
                    {t("LABEL.EQUIPMENT_TYPE")}
                  </div>
                  <div className={style.meetingRoom_info_value}>
                    {props.resource.extendedProps.DEVICE_TYPE === "CD0301"
                      ? "CISCO"
                      : props.resource.extendedProps.DEVICE_TYPE === "CD0302"
                      ? "POLY"
                      : props.resource.extendedProps.DEVICE_TYPE === "CD0307"
                      ? "NEAT"
                      : "Third party"}
                    <div className={style.endpoint_info_item}>
                      <div className={style.endpoint_info_label}>ID</div>
                      <div className={style.endpoint_info_value}>
                        {props.resource.extendedProps.CISCO_ID}
                      </div>
                    </div>
                    <div className={style.endpoint_info_item}>
                      <div className={style.endpoint_info_label}>PW</div>
                      <div className={style.endpoint_info_value}>
                        {props.resource.extendedProps.CISCO_PW}
                      </div>
                    </div>
                  </div>
                </div>
                <div className={style.meetingRoom_info_area}>
                  <div className={style.meetingRoom_info_label}>
                    <span />
                    {t("LABEL.USE_YN")}
                  </div>
                  <div className={style.meetingRoom_info_value}>
                    {props.resource.extendedProps.USE_YN === "Y" ? "Yes" : "No"}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      }
    >
      <Detail className="cursor" />
    </Popover>
  );
}

export default MeetingRoomInfoModal;
